import { Navigate } from "react-router-dom";
import { useUser } from "@/contexts/UserContext";
import { Roles } from "@/shared/constants/roles";
import Dashboard from "./Dashboard";

const Index = () => {
  const { user } = useUser();

  if (user?.roles?.includes(Roles.Admin)) {
    return <Navigate to="/admin/reports" replace />;
  }

  if (user?.roles?.includes(Roles.Supervisor)) {
    return <Navigate to="/admin/users" replace />;
  }

  if (user?.roles?.includes(Roles.ContentManager)) {
    return <Navigate to="/admin/courses" replace />;
  }

  return <Dashboard />;
};

export default Index;
